import { render } from "./SavedCollections.vue?vue&type=template&id=c77144fa"
import script from "./SavedCollections.vue?vue&type=script&lang=js"
export * from "./SavedCollections.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__